import React from "react";
import UseGetDashBoardData from "../../../../Components/Hooks/useDashboardData";
import { ModernStatWidget } from "./DashboardCard";

function SuppliersDashboard() {
  const { data } = UseGetDashBoardData(`/dashboard/supplierStats`);
  const percentage = parseFloat(data?.new_suppliers_count) || 0;
  const isNegative = percentage < 0;

  const SupplierIcon = (
    <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
    </svg>
  );

  return (
    <ModernStatWidget
      title="Total Suppliers"
      value={data?.total_suppliers_count || 0}
      percentage={percentage}
      isNegative={isNegative}
      icon={SupplierIcon}
      bgColor="bg-sky-500/10"
      iconColor="text-sky-600"
      badgeLabel="new this month"
    />
  );
}

export default SuppliersDashboard;
